module.exports = __webpack_public_path__ + "img/logoFold.dba6dabc.png";